import styled, { css } from 'styled-components';

import {
  ArrowBack,
  ArrowForward,
  CircleOutlined,
  CircleRounded,
  Close,
} from '@mui/icons-material';
import { Box, Card as MuiCard, Typography } from '@mui/material';
import { DateCalendar } from '@mui/x-date-pickers-pro';
import Bad from 'assets/icons/mood-tracker/bad.svg';
import Good from 'assets/icons/mood-tracker/good.svg';
import Ok from 'assets/icons/mood-tracker/ok.svg';
import Quotes from 'assets/icons/mood-tracker/quotes.svg';
import VeryBad from 'assets/icons/mood-tracker/very-bad.svg';
import VeryGood from 'assets/icons/mood-tracker/very-good.svg';

export const Wrapper = styled(Box)`
  scroll-behavior: smooth;
`;

export const Calendar = styled(DateCalendar)`
  ${({ theme }) => css`
    width: 100%;
    min-height: ${theme.spacing(63)};

    .MuiDayCalendar-header {
      justify-content: space-between;
      background-color: ${theme.yoga.colors.backgroundLight};

      padding: 10px 20px;

      span {
        height: 20px;
        width: 36px;
        margin: 0;
      }

      border-bottom: 1px solid ${theme.yoga.colors.tableBorder};
      margin-bottom: ${theme.spacing(1)};
    }

    .MuiDayCalendar-weekContainer {
      margin: 0 20px;
      justify-content: space-between;
      max-width: 346px;

      > button,
      > div {
        margin: 0;

        height: 100%;
        &:focus {
          background-color: ${theme.yoga.colors.backgroundLight};
          border-radius: ${theme.spacing(1)};
          color: #000;
          border: 0;
        }

        &:hover {
          background-color: ${theme.yoga.colors.backgroundLight};
          border-radius: ${theme.spacing(1)};
          color: #000;
        }
      }
    }

    .MuiPickersDay-root {
      width: ${theme.spacing(4.5)};
      height: ${theme.spacing(5.5)};
      margin-top: ${theme.spacing(1)};
      margin-bottom: ${theme.spacing(1)};
    }

    .MuiPickersDay-today {
      background-color: ${theme.yoga.colors.backgroundLight};
      border-radius: ${theme.spacing(1)};
      color: #000;
      border: 0;
    }

    .Mui-selected {
      background-color: ${theme.yoga.colors.backgroundLight};
      border-radius: ${theme.spacing(1)};
      color: #000;
      border: 0;
    }

    .MuiPickersSlideTransition-root {
      min-height: ${theme.spacing(50)};
    }
  `}
`;

export const Month = styled(Typography)`
  &::first-letter {
    text-transform: uppercase;
  }
`;

export const BackArrow = styled(ArrowBack)`
  ${({ theme }) => css`
    height: ${theme.yoga.fontSizes.large}px;
    width: ${theme.yoga.fontSizes.large}px;
    fill: ${theme.palette.primary.main};
  `}
`;

export const ForwardArrow = styled(ArrowForward)`
  ${({ theme }) => css`
    height: ${theme.yoga.fontSizes.large}px;
    width: ${theme.yoga.fontSizes.large}px;
    fill: ${theme.palette.primary.main};
  `}
`;

export const PastDayIcon = styled(CircleOutlined)`
  ${({ theme }) => css`
    height: ${theme.yoga.fontSizes.large}px;
    width: ${theme.yoga.fontSizes.large}px;
    fill: ${theme.yoga.colors.disabled};
  `}
`;

export const FutureDayIcon = styled(CircleRounded)`
  ${({ theme }) => css`
    height: ${theme.yoga.fontSizes.large}px;
    width: ${theme.yoga.fontSizes.large}px;
    fill: ${theme.yoga.colors.disabled};
  `}
`;

export const CloseIcon = styled(Close)`
  ${({ theme }) => css`
    height: ${theme.spacing(3)};
    width: ${theme.spacing(3)};
  `}
`;

export const QuotesIcon = styled(Quotes)`
  ${({ theme }) => css`
    width: ${theme.spacing(2)};
    height: ${theme.spacing(2)};
  `}
`;

export const Card = styled(MuiCard)`
  ${({ theme }) => css`
    background-color: ${theme.yoga.colors.white};
    padding: ${theme.spacing(2)};
  `}
`;

export const VeryGoodIcon = styled(VeryGood)`
  ${({ theme }) => css`
    width: ${theme.yoga.spacing.medium}px;
    height: ${theme.yoga.spacing.medium}px;
    fill: ${theme.yoga.colors.primary};
  `}
`;

export const GoodIcon = styled(Good)`
  ${({ theme }) => css`
    width: ${theme.yoga.spacing.medium}px;
    height: ${theme.yoga.spacing.medium}px;
    fill: #7c2c92;
  `}
`;

export const OkIcon = styled(Ok)`
  ${({ theme }) => css`
    width: ${theme.yoga.spacing.medium}px;
    height: ${theme.yoga.spacing.medium}px;
    fill: #7654bc;
  `}
`;

export const BadIcon = styled(Bad)`
  ${({ theme }) => css`
    width: ${theme.yoga.spacing.medium}px;
    height: ${theme.yoga.spacing.medium}px;
    fill: #5d7bd1;
  `}
`;

export const VeryBadIcon = styled(VeryBad)`
  ${({ theme }) => css`
    width: ${theme.yoga.spacing.medium}px;
    height: ${theme.yoga.spacing.medium}px;
    fill: #379bcd;
  `}
`;
